module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Report","select_organization":"Show report for organization:"},"nl":{"title":"Rapport","select_organization":"Toon rapport van organisatie:"}}')
  delete Component.options._Ctor
}
